import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import MyWork from './pages/MyWork';
import More from './pages/More';
import ProjectDetail from './pages/ProjectDetail';
import Admin from './pages/Admin';
import Shop from './pages/Shop';
import ShopProduct from './pages/ShopProduct';
import Collection from './pages/Collection';

const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || '/admin';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<MyWork />} />
        <Route path="/more" element={<More />} />
        <Route path="/project/:projectId" element={<ProjectDetail />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/product/:productId" element={<ShopProduct />} />
        <Route path="/shop/collection/:categoryId" element={<Collection />} />
        <Route path={ADMIN_PATH} element={<Admin />} />
      </Routes>
    </Router>
  );
}

export default App;
